module.exports = __webpack_public_path__ + "img/activityListBanner1.9905d800.png";